export const emailValidation = (email) => {
  const regex = new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}");
  return regex.test(email);
};

export const phoneValidation = (phone) => {
  const regex = /^(010)?[0-9]{4}?[0-9]{4}$/;
  return regex.test(phone);
};
